import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Layout from "./components/Layout";
import Users from "./components/Users";
import Settings from "./components/Settings";
import AdminDashboard from "./components/AdminDashboard";
import DashboardRedirect from "./components/DashboardRedirect";
import LoginPage from "./components/Login";
import Wallet from "./components/WalletUpdate";
import Deposit from "./components/Deposit";
import Withdraw from "./components/Withdraw";
import House from "./components/House";
import History from "./components/History";
import Game from "./components/Games";
import GamesLog from "./components/WinSetting";
import SEO from "./components/SeoManager";
import NotificationSettings from "./components/NotificationSettings";
import WinSettings from "./components/WinSetting";
import Payments from "./components/Payment";
import ManualDeposit from "./components/ManualDeposit";
import ManualWithdrawal from "./components/ManualWithdrawal";
import ChangePassword from "./components/ChangePassword";
import DepositBonus from "./components/DepositBonus";
import DepositCommissionLevel from "./components/LevelCommission/DepositCommissionLevel";
import BetCommissionLevel from "./components/LevelCommission/BetCommissionLevel";
import Level from "./components/Level";
import StateList from "./components/StateRestrictions/StateList";
import TeamView from "./components/B2B/Subordinates";
import AddSubordinateAccount from "./components/B2B/AddSubordinateAccount.jsx";
import PanelDeposits from "./components/PanelDeposits";
import CreditsHistory from "./components/B2B/CreditsHistory";
import MyB2BDepositsHistory from "./components/B2B/MyB2BDepositsHistory";
import TeamB2BDepositsHistory from "./components/B2B/TeamB2BDepositsHistory";
import PaymentSettings from "./components/B2B/PaymentSettings";
import ProfileSection from "./components/Profile";
import Setting from "./components/Setting";
import LiveBets from "./components/LiveBets";
import WebsiteBanner from "./components/Banners/WebsiteBanner";
import AddBanners from "./components/Banners/AddOrEditBanner";
import AddOrEditBanner from "./components/Banners/AddOrEditBanner";
import MarqueeSettings from "./components/Banners/MarqueeSettings";
import Banking from "./components/Banking/banking";
import AddBank from "./components/Banking/AddBank";
import BankUpi from "./components/Banking/BankUpi";
import BankUpiEdit from "./components/Banking/BankUpiEdit";
import UsdtBanking from "./components/BankingUsdt/UsdtBanking";
import AddUSDTBank from "./components/BankingUsdt/AddUSDTBank";
import BankUSDT from "./components/BankingUsdt/BankUSDT";
import BankUSDTEdit from "./components/BankingUsdt/BankUSDTEdit";

function App() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const activeTab = localStorage.getItem("active_tab"); // Get active_tab from localStorage

  console.log(role);

  const ProtectedRoutes = () => {
    return token ? <Outlet /> : <Navigate to="/login" replace />;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<DashboardRedirect />} />

            <Route path="changePassword" element={<ChangePassword />} />

            <Route path="deposit" element={<Deposit />} />

            <Route path="house" element={<House />} />
            <Route path="history" element={<History />} />
            <Route path="manual-withdrawal" element={<ManualWithdrawal />} />
            <Route path="panel-deposits" element={<PanelDeposits />} />

            <Route path="/creditsHistory" element={<CreditsHistory />} />
            <Route path="/creditsHistory/:id" element={<CreditsHistory />} />
            <Route path="/Deposits" element={<ManualDeposit />} />

            <Route path="/B2BDeposits" element={<MyB2BDepositsHistory />} />
            <Route path="/B2BDeposits/:id" element={<MyB2BDepositsHistory />} />
            <Route path="/panelGames" element={<LiveBets />} />

            <Route
              path="/TeamB2BDeposits"
              element={<TeamB2BDepositsHistory />}
            />
            <Route
              path="/TeamB2BDeposits/:id"
              element={<TeamB2BDepositsHistory />}
            />
            <Route path="/B2BPaymentSettings" element={<PaymentSettings />} />

            <Route path="/profile" element={<ProfileSection />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/banners" element={<WebsiteBanner />} />
            <Route path="/banners/create" element={<AddOrEditBanner />} />
            <Route path="/banners/edit/:id" element={<AddOrEditBanner />} />
            <Route path="/marquee" element={<MarqueeSettings />} />
            <Route path="/banking" element={<Banking />} />
            <Route path="/banking/edit/:paymentType" element={<AddBank />} />
            <Route path="/banking/create/upi" element={<BankUpi />} />
            <Route path="/banking/create/upi/edit/:id" element={<BankUpiEdit />} />

            <Route path="/banking/usdt" element={<UsdtBanking />} />
            {/* <Route path="/banking/create/usdt" element={<AddUSDTBank />} /> */}
            <Route path="/banking/create/usdt" element={<BankUSDT />} />
            <Route path="/banking/create/usdt/edit/:id" element={<BankUSDTEdit />} />

            <Route path="/subordinate" element={<TeamView />} />
            <Route path="/subordinate/:id/:role" element={<TeamView />} />
            <Route path="/addAccount" element={<AddSubordinateAccount />} />

            <Route path="users" element={<Users />} />
                <Route path="settings" element={<Settings />} />
                <Route path="level" element={<Level />} />
                <Route path="stateList" element={<StateList />} />
                <Route path="depositBonus" element={<DepositBonus />} />
                <Route
                  path="DepositCommissionLevel"
                  element={<DepositCommissionLevel />}
                />
                <Route
                  path="BetCommissionLevel"
                  element={<BetCommissionLevel />}
                />
                <Route path="games" element={<Game />} />
                <Route path="win-settings" element={<WinSettings />} />
            {/* {activeTab === "B2B" && (
              <>
                <Route path="/subordinate/all" element={<TeamView />} />
                <Route
                  path="/subordinate/:roleId/all/:nextRole"
                  element={<TeamView />}
                />
                <Route
                  path="/subordinate"
                  element={<Navigate to="/subordinate/all" />}
                />
                <Route path="/subordinate/:role" element={<TeamView />} />
              </>
            )}
            {activeTab === "B2C" && (
              <>
                
              </>
            )} */}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
